import { cn, platformProps } from "../../lib";
import { Box, Text } from "../../primitives";
import type { AccountMenuPanelSectionProps } from "./types";

/**
 * Section slot of AccountMenuPanel — a group of rows (typically
 * <ListItem /> children, but accepts anything).
 */
export const AccountMenuPanelSection = ({
  children,
  label,
  className,
  testID,
}: AccountMenuPanelSectionProps) => (
  <Box
    {...platformProps({ testID, slot: "account-menu-panel-section" })}
    as="section"
    accessibilityLabel={label}
    className={cn(
      "py-spacing-sm border-luce-neutral-border-mediumEmphasis flex flex-col border-b",
      className,
    )}
  >
    {label ? (
      <Text className="px-spacing-lg pb-spacing-xs text-caption-sm text-luce-neutral-foreground-intermediate font-inter-medium uppercase tracking-wide">
        {label}
      </Text>
    ) : null}
    {children}
  </Box>
);

AccountMenuPanelSection.displayName = "AccountMenuPanel.Section";
